import React, { useState } from 'react';
import {
    Box,
    Container,
    FormControlLabel,
    Switch,
    Typography,
} from '@mui/material';
import { useDarkMode } from '../App';
import { savePreference } from '../utils/preferences';

const Settings = () => {
    const storedUser = JSON.parse(localStorage.getItem('user')) || {};
    const { darkMode, setDarkMode } = useDarkMode();
    const isEditor = storedUser.role === 'editor' || storedUser.role === 'admin';

    const [showAll, setShowAll] = useState(localStorage.getItem('showAllRecipes') === 'true');

    return (
        <Container maxWidth="sm" sx={{ mt: 6, pb: 12 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 4 }}>Settings</Typography>

            <Typography variant="h6" sx={{ mb: 2 }}>Appearance</Typography>
            <FormControlLabel
                control={<Switch checked={darkMode} onChange={(e) => { setDarkMode(e.target.checked); savePreference('darkMode', e.target.checked); }} />}
                label="Dark mode"
            />
            {isEditor && (
                <Box sx={{ mt: 1 }}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={!showAll}
                                onChange={(e) => {
                                    const familyOnly = e.target.checked;
                                    setShowAll(!familyOnly);
                                    savePreference('showAllRecipes', !familyOnly);
                                }}
                            />
                        }
                        label="Family recipes only"
                    />
                </Box>
            )}
        </Container>
    );
};

export default Settings;
